const DataStoreNames = Object.freeze({
    CATEGORIES: 'categories',
    FIELDS: 'fields',
    GIFT_AID_RATES: 'giftAidRates',
    GIFT_VOUCHERS: 'giftVouchers',
    ITEM_BARCODES: 'itemBarcodes',
    ITEM_INSTANCE_ORDER_MAP: 'itemInstanceOrderMap',
    ITEM_OPTIONS: 'itemOptions',
    IMAGES: 'images',
    KITCHEN_ZONES: 'kitchenZones',
    MARKETING_PREFERENCES: 'marketingPreferences',
    MEMBERSHIP_PLANS: 'membershipPlans',
    OFFERS: 'offers',
    ONLINE_TASKS: 'onlineTasks',
    OPTION_SETS: 'optionSets',
    ORDERS: 'orders',
    PRIVILEGES: 'privileges',
    PRODUCTS: 'products',
    RETURN_REASONS: 'returnReasons',
    SESSIONS: 'sessions',
    SESSION_EVENTS: 'sessionEvents',
    TEMPLATES: 'templates',
    TEST: 'test',
    TICKETS: 'tickets',
    USER_SESSIONS: 'userSessions',
});

module.exports = DataStoreNames;
